import { createContext, useContext, useEffect, useState } from "react";

export const CONTACT = {
  email: "hello@ecomobilesolution.fr",
  phone: "+33 7 87 18 99 89",
  telHref: "tel:+33787189989",
  wa: "https://wa.me/33787189989",
  address: "ZI N2 CD70 route d'Hérin, 59220 Rouvignies, France",
  region: "Valenciennes — Hauts-de-France",
  siren: "982 341 869 R.C.S. Valenciennes",
};

const dict = {
  fr: {
    nav: {
      home: "Accueil",
      about: "Qui sommes-nous",
      activities: "Nos activités",
      partnerships: "Partenariats",
      contact: "Contact",
      cta: "Proposer un lot",
    },
    home: {
      eyebrow: "Valorisation smartphone & pièces détachées — B2B",
      titleLines: ["Achat & valorisation", "de smartphones", "et composants"],
      sub: "Donnons une nouvelle valeur à vos smartphones et composants électroniques. Eco Mobile Solutions propose aux professionnels des solutions d'achat et de valorisation de smartphones cassés, bloqués ou défectueux, ainsi que de composants électroniques, fonctionnels ou non.",
      ctaLot: "Proposer un lot",
      ctaActivities: "Découvrir nos activités",
      ticker: "+10 ans d'expertise — Valenciennes, Hauts-de-France — Relations B2B",
      tagLot: "Smartphones & composants",
      tagActive: "Achat & valorisation B2B",
      marquee: [
        "Écrans cassés",
        "Cartes mères HS",
        "Smartphones cassés",
        "Téléphones bloqués",
        "Nappes usagées",
        "Modules caméra",
        "Pièces détachées",
        "Démantèlement sur place",
        "Lots professionnels",
      ],
      buy: {
        num: "01",
        eyebrow: "Nos activités",
        title: "Ce que nous rachetons",
        sub: "Nous rachetons vos écrans cassés, cartes mères HS, téléphones cassés, défectueux, bloqués (iCloud, Google, MDM) et autres pièces détachées, fonctionnels ou non.",
        items: [
          { title: "Écrans cassés" },
          { title: "Cartes mères" },
          { title: "Smartphones cassés" },
          { title: "Téléphones bloqués" },
          { title: "Nappes usagées" },
          { title: "Autres pièces détachées" },
        ],
        cta: "Vous avez un lot à valoriser ?",
        ctaBtn: "Proposer un lot",
      },
      strengths: {
        num: "02",
        eyebrow: "Nos points forts",
        title: "Un partenaire industriel fiable",
        items: [
          {
            stat: "+10 ans",
            label: "d'expérience dans le secteur mobile et la valorisation des équipements.",
          },
          {
            stat: "Sur place",
            label: "démantèlement et traitement des équipements dans nos ateliers.",
          },
          {
            stat: "B2B",
            label: "relations avec les grands acteurs du reconditionnement et de la réparation.",
          },
        ],
      },
      env: {
        num: "03",
        eyebrow: "Environnement",
        title: "Une gestion responsable des matières issues du traitement",
        body: "Nous travaillons avec les leaders français du recyclage pour assurer un traitement responsable de vos déchets électroniques.",
        partners: ["Ecologic", "Citeo", "Corepile"],
      },
      cta: {
        title: "Vous disposez de lots importants de smartphones ou composants irréparables ?",
        button: "Proposer un lot",
      },
    },
    about: {
      eyebrow: "Qui sommes-nous",
      title: "Eco Mobile Solutions",
      lead: "Spécialisée dans l'achat et la valorisation de smartphones et composants défectueux, notre entreprise est implantée dans la région de Valenciennes.",
      imageTag: "ROUVIGNIES — 59220, FRANCE",
      blocks: [
        {
          num: "01",
          title: "Plus de 10 ans d'expérience dans le secteur mobile",
          body: "Notre savoir-faire repose sur la connaissance des équipements mobiles, l'évaluation des lots professionnels et nos capacités de démantèlement et de traitement sur place.",
        },
        {
          num: "02",
          title: "Des relations commerciales durables",
          body: "Nous recherchons des relations commerciales durables avec les acteurs du reconditionnement et de la réparation.",
        },
        {
          num: "03",
          title: "Une gestion responsable des matières issues du traitement",
          body: "Les flux de déchets issus des opérations doivent être orientés vers les filières appropriées.",
        },
      ],
      facts: {
        regionLabel: "Région",
        legalLabel: "Immatriculation",
        emailLabel: "Email",
      },
    },
    activities: {
      eyebrow: "Nos activités",
      title: "Ce que nous achetons",
      lead: "Nous étudions les propositions de lots de smartphones et composants électroniques, y compris les équipements irréparables.",
      cards: [
        {
          num: "01",
          title: "Smartphones",
          desc: "Cassés, bloqués, défectueux ou irréparables.",
          items: ["Appareils cassés", "Téléphones bloqués", "Défectueux ou irréparables"],
        },
        {
          num: "02",
          title: "Composants électroniques",
          desc: "Écrans cassés, cartes mères, nappes, modules caméra et pièces détachées, fonctionnels ou non.",
          items: ["Écrans cassés", "Cartes mères", "Nappes usagées", "Modules caméra", "Pièces détachées"],
        },
        {
          num: "03",
          title: "Valorisation des lots",
          desc: "Évaluation et proposition d'achat pour des volumes professionnels.",
          items: ["Évaluation des lots", "Proposition d'achat", "Volumes professionnels"],
        },
      ],
      ctaTitle: "Un lot à nous proposer ?",
      ctaButton: "Proposer un lot",
    },
    partnerships: {
      eyebrow: "Partenariats professionnels",
      titleLines: ["Nous rachetons vos lots de", "smartphones et composants,", "même irréparables."],
      body: "Notre activité s'adresse en priorité aux grands reconditionneurs, centres de réparation à fort volume, grossistes et distributeurs.",
      audienceLabel: "Nous travaillons avec",
      audience: ["Reconditionneurs", "Centres de réparation", "Grossistes", "Distributeurs"],
      stepsTitle: "Comment ça marche ?",
      steps: [
        {
          num: "01",
          title: "Inventaire",
          body: "Envoyez-nous la liste de vos pièces avec photos.",
        },
        {
          num: "02",
          title: "Offre de reprise",
          body: "Nous vous proposons un prix sous 24 h.",
        },
        {
          num: "03",
          title: "Logistique",
          body: "Nous organisons la collecte ou vous expédiez.",
        },
        {
          num: "04",
          title: "Contrôle qualité",
          body: "Vérification et validation de votre lot.",
        },
        {
          num: "05",
          title: "Paiement",
          body: "Règlement rapide sous 48 h.",
        },
        {
          num: "06",
          title: "Recyclage",
          body: "Traitement écologique des déchets.",
        },
      ],
      cta: {
        title: "Prêt à valoriser vos stocks ?",
        button: "Proposer un lot",
      },
    },
    contact: {
      eyebrow: "Contact",
      title: "Proposez-nous vos lots",
      lead: "Décrivez votre matériel pour recevoir un premier retour de notre équipe.",
      infoTitle: "Nos coordonnées",
      emailLabel: "Email",
      phoneLabel: "Téléphone",
      waLabel: "WhatsApp",
      waCta: "Discuter sur WhatsApp",
      addressLabel: "Adresse",
      regionLabel: "Valenciennes — Hauts-de-France",
      companyLabel: "Entreprise",
      companyPlaceholder: "Votre société",
      nameLabel: "Nom du contact",
      namePlaceholder: "Votre nom",
      phoneFieldLabel: "Téléphone",
      phonePlaceholder: "+33 6 12 34 56 78",
      emailFieldLabel: "Email",
      emailPlaceholder: "vous@societe.com",
      materielLabel: "Type de matériel",
      materiels: ["Smartphones", "Composants électroniques", "Lots mixtes"],
      quantityLabel: "Quantité approximative",
      quantityPlaceholder: "Ex. 200 — 500 unités",
      descriptionLabel: "Description du lot",
      descriptionPlaceholder: "Références, état du matériel, quantités…",
      consent: "J'accepte que mes données soient utilisées pour répondre à ma demande.",
      submit: "Envoyer ma demande",
      sending: "Envoi en cours…",
      sent: "Demande envoyée. Un email de confirmation vous a été adressé, un agent reviendra vers vous rapidement.",
      error: "L'envoi a échoué. Réessayez ou écrivez-nous directement.",
      required: "Merci de compléter les champs obligatoires.",
      hint: "Réponse par email — hello@ecomobilesolution.fr",
    },
    footer: {
      tagline: "Achat et valorisation de smartphones et composants défectueux pour les professionnels.",
      navTitle: "Navigation",
      contactTitle: "Contact",
      legal: "Mentions légales et politique de confidentialité en cours de rédaction.",
      rights: "Tous droits réservés.",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About us",
      activities: "Activities",
      partnerships: "Partnerships",
      contact: "Contact",
      cta: "Submit a lot",
    },
    home: {
      eyebrow: "Smartphone & parts valorization — B2B",
      titleLines: ["Buying & valuing", "smartphones", "and components"],
      sub: "We give new value to your smartphones and electronic components. Eco Mobile Solutions provides professionals with buying and valorization solutions for broken, blocked or defective smartphones, as well as electronic components — functional or not.",
      ctaLot: "Submit a lot",
      ctaActivities: "Discover our activities",
      ticker: "+10 years of expertise — Valenciennes, France — B2B relationships",
      tagLot: "Smartphones & components",
      tagActive: "Buying & valorization B2B",
      marquee: [
        "Broken screens",
        "Faulty motherboards",
        "Broken smartphones",
        "Blocked phones",
        "Used flex cables",
        "Camera modules",
        "Spare parts",
        "On-site dismantling",
        "Professional lots",
      ],
      buy: {
        num: "01",
        eyebrow: "Our activities",
        title: "What we buy",
        sub: "We buy your broken screens, faulty motherboards, broken phones, defective devices, blocked phones (iCloud, Google, MDM) and other spare parts — functional or not.",
        items: [
          { title: "Broken screens" },
          { title: "Motherboards" },
          { title: "Broken smartphones" },
          { title: "Blocked phones" },
          { title: "Used flex cables" },
          { title: "Other spare parts" },
        ],
        cta: "Got a lot to value?",
        ctaBtn: "Submit a lot",
      },
      strengths: {
        num: "02",
        eyebrow: "Our strengths",
        title: "A reliable industrial partner",
        items: [
          {
            stat: "+10 years",
            label: "of experience in the mobile industry and equipment valorization.",
          },
          {
            stat: "On-site",
            label: "dismantling and processing of equipment in our workshops.",
          },
          {
            stat: "B2B",
            label: "relationships with the industry's leading reconditioning and repair players.",
          },
        ],
      },
      env: {
        num: "03",
        eyebrow: "Environment",
        title: "Responsible management of materials from processing",
        body: "We work with France's recycling leaders to ensure responsible processing of your electronic waste.",
        partners: ["Ecologic", "Citeo", "Corepile"],
      },
      cta: {
        title: "Do you hold large volumes of smartphones or non-repairable components?",
        button: "Submit a lot",
      },
    },
    about: {
      eyebrow: "About us",
      title: "Eco Mobile Solutions",
      lead: "Specialized in the purchase and valorization of defective smartphones and components, our company is based in the Valenciennes region, France.",
      imageTag: "ROUVIGNIES — 59220, FRANCE",
      blocks: [
        {
          num: "01",
          title: "Over 10 years of experience in the mobile industry",
          body: "Our expertise is built on deep knowledge of mobile equipment, professional lot assessment, and on-site dismantling and processing capabilities.",
        },
        {
          num: "02",
          title: "Durable business relationships",
          body: "We seek long-lasting commercial relationships with reconditioning and repair professionals.",
        },
        {
          num: "03",
          title: "Responsible management of processed materials",
          body: "Waste streams from our operations must be routed to the appropriate channels.",
        },
      ],
      facts: {
        regionLabel: "Region",
        legalLabel: "Registration",
        emailLabel: "Email",
      },
    },
    activities: {
      eyebrow: "Our activities",
      title: "What we buy",
      lead: "We review proposals for lots of smartphones and electronic components, including beyond-repair equipment.",
      cards: [
        {
          num: "01",
          title: "Smartphones",
          desc: "Broken, blocked, defective or beyond repair.",
          items: ["Broken devices", "Blocked phones", "Defective or beyond repair"],
        },
        {
          num: "02",
          title: "Electronic components",
          desc: "Broken screens, motherboards, flex cables, camera modules and spare parts — functional or not.",
          items: ["Broken screens", "Motherboards", "Used flex cables", "Camera modules", "Spare parts"],
        },
        {
          num: "03",
          title: "Lot valorization",
          desc: "Assessment and purchase offer for professional volumes.",
          items: ["Lot assessment", "Purchase offer", "Professional volumes"],
        },
      ],
      ctaTitle: "Got a lot to submit?",
      ctaButton: "Submit a lot",
    },
    partnerships: {
      eyebrow: "Professional partnerships",
      titleLines: ["We buy your lots of", "smartphones and components,", "even beyond repair."],
      body: "Our activity is aimed primarily at large reconditioners, high-volume repair centers, wholesalers and distributors.",
      audienceLabel: "We work with",
      audience: ["Reconditioners", "Repair centers", "Wholesalers", "Distributors"],
      stepsTitle: "How it works",
      steps: [
        {
          num: "01",
          title: "Inventory",
          body: "Send us the list of your parts with photos.",
        },
        {
          num: "02",
          title: "Buy-back offer",
          body: "We offer you a price within 24 hours.",
        },
        {
          num: "03",
          title: "Logistics",
          body: "We organize collection or you ship to us.",
        },
        {
          num: "04",
          title: "Quality control",
          body: "Verification and validation of your lot.",
        },
        {
          num: "05",
          title: "Payment",
          body: "Fast settlement within 48 hours.",
        },
        {
          num: "06",
          title: "Recycling",
          body: "Eco-friendly processing of waste.",
        },
      ],
      cta: {
        title: "Ready to value your stock?",
        button: "Submit a lot",
      },
    },
    contact: {
      eyebrow: "Contact",
      title: "Send us your lots",
      lead: "Describe your equipment to get a first response from our team.",
      infoTitle: "Our contact details",
      emailLabel: "Email",
      phoneLabel: "Phone",
      waLabel: "WhatsApp",
      waCta: "Chat on WhatsApp",
      addressLabel: "Address",
      regionLabel: "Valenciennes — Hauts-de-France",
      companyLabel: "Company",
      companyPlaceholder: "Your company",
      nameLabel: "Contact name",
      namePlaceholder: "Your name",
      phoneFieldLabel: "Phone",
      phonePlaceholder: "+33 6 12 34 56 78",
      emailFieldLabel: "Email",
      emailPlaceholder: "you@company.com",
      materielLabel: "Equipment type",
      materiels: ["Smartphones", "Electronic components", "Mixed lots"],
      quantityLabel: "Approximate quantity",
      quantityPlaceholder: "e.g. 200 — 500 units",
      descriptionLabel: "Lot description",
      descriptionPlaceholder: "References, equipment condition, quantities…",
      consent: "I agree that my data may be used to respond to my request.",
      submit: "Send my request",
      sending: "Sending…",
      sent: "Request sent. A confirmation email has been sent to you, an agent will get back to you shortly.",
      error: "Sending failed. Please try again or email us directly.",
      required: "Please fill in the required fields.",
      hint: "Reply by email — hello@ecomobilesolution.fr",
    },
    footer: {
      tagline: "Purchase and valorization of defective smartphones and components for professionals.",
      navTitle: "Navigation",
      contactTitle: "Contact",
      legal: "Legal notice & privacy policy — to be completed before publication.",
      rights: "All rights reserved.",
    },
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("ems-lang") || "fr");
  useEffect(() => {
    localStorage.setItem("ems-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang, t: dict[lang] }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
